import { gql } from '@apollo/client';

export const DASHBOARD_SCHOOLS = gql`
  query DashboardSchools($input: FilterArgs) {
    totalSchoolsInApprovedSessions(input: $input) {
      month
      count
    }
  }
`;
